/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/models/planet.glb -o Planet.jsx -r public --transform 
Files: public/models/planet.glb [3.01MB] > C:\Users\smc91\Desktop\0812\web4\planet-transformed.glb [329.67KB] (89%)
Author: cmzw (https://sketchfab.com/cmzw)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/stylized-planet-789725db86f547fc9163b00f302c3e70
Title: Stylized planet
*/

import React, { useRef, useLayoutEffect, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'

export default function Planet({
  scrollYVal = 0,
  scale = 1,
  base = [0, -2, -3],
  turnPixels = 800,
  startPx = 0,
  repeat = true,

  fadeStart = 600,   
  fadeEnd   = 1000,  
}) {
  const group = useRef();
  const { nodes, materials } = useGLTF(process.env.PUBLIC_URL + '/models/planet.glb');


  useEffect(() => {

    Object.values(materials).forEach((mat) => {
      if (!mat) return;
      mat.transparent = true;

    });
  }, [materials]);

  useLayoutEffect(() => {
    if (group.current) group.current.position.set(...base);
  }, [base]);

  useFrame(() => {
    if (!group.current) return;

    const raw = (scrollYVal - startPx) / turnPixels;
    const t = repeat ? Math.max(raw, 0) : Math.min(Math.max(raw, 0), 1);
    group.current.rotation.y = t * Math.PI * 0.5;
    group.current.scale.setScalar(scale * raw * 3 + 3);


    const p = (scrollYVal - fadeStart) / Math.max(1, fadeEnd - fadeStart);
    let alpha = 1 - Math.min(Math.max(p, 0), 1);



    if (materials.Clouds)  materials.Clouds.opacity  = alpha;
    if (materials.Planet)  materials.Planet.opacity  = alpha;
  });

  return (
    <group ref={group} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="GLTF_SceneRootNode" rotation={[0.031, 0, 0.064]}>
          <group name="Clouds_1">
            <mesh geometry={nodes.Object_4.geometry} material={materials.Clouds} />
          </group>
          <group name="Planet_2">
            <mesh geometry={nodes.Object_6.geometry} material={materials.Planet} />
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload(process.env.PUBLIC_URL + '/models/planet.glb');
